import { render, staticRenderFns } from "./MergeZonesProcessDialog.vue?vue&type=template&id=6a3b0c9b"
import script from "./MergeZonesProcessDialog.vue?vue&type=script&lang=js"
export * from "./MergeZonesProcessDialog.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports